import React from 'react'
import styles from './SegmentationBoxInfo.module.css'
import { SegmentationType, TransactionType } from '../../../@types/types'
import { getMetadataConfig } from './SegmentationBoxInfo.config'
import { SegmentationBoxHeader } from './SegmentationBoxHeader'
import { SegmentationBoxBody } from './SegmentationBoxBody'

type SegmentationBoxInfoProps = {
  type?: SegmentationType | null
  transaction?: TransactionType | 'SHORT_TERM_ACCOMMODATION' | null
}

export const SegmentationBoxInfo = ({ type, transaction }: SegmentationBoxInfoProps) => {
  const metadataConfig = getMetadataConfig(type, transaction)

  return (
    <div className={'grid grid-flex grid-justify-center'}>
      <div className={`${styles.wrapper}`}>
        <SegmentationBoxHeader backgroundImage={metadataConfig.backgroundImage} height={metadataConfig.headerHeight} />
        <SegmentationBoxBody
          pointsTitle={metadataConfig.pointsTitle}
          pointsTitleClassName={metadataConfig.pointsTitleClassName}
          points={metadataConfig.points}
          securityNoteKey={metadataConfig.securityNoteKey}
          securityLink={metadataConfig.securityLink}
          selectedSegmentation={type}
          transactionType={transaction}
        />
      </div>
    </div>
  )
}
